import { useState } from "react";
import { createPortal } from "react-dom";
import axios from "axios";
import { useModal } from "@/comn/hooks";
import { Icon } from "@/comn/components";
import { _TEST1234 } from "@/comn/features/config/ApiConfig";
import { useResourceContext } from "@/comn/features/context/ResourceContext";
import { useTranslation } from "react-i18next";

const Panel = (props: any) => {
    const { setIsOpen } = props;

    const { t } = useTranslation();
    const { openModal } = useModal();

    const { getResourceRefs, updateResource, bulkUpdateIdb } = useResourceContext();
    const [loading, setLoading] = useState(false);

    const syncAll = () => {
        openModal({
            content: "msg.osc.00130",
            onConfirm: async () => {
                setLoading(true);
                try {
                    const PORTAL_API = _TEST1234.PORTAL_API_ENV;
                    const PATH = "/api/v1/ptl/comn/comnppup/codeGroup/all?langCd=EN";
                    const response = await axios.get(PORTAL_API + PATH);
                    // console.log(response.data.codeGroupList.content);
                    await bulkUpdateIdb(response.data.codeGroupList.content);
                } catch (error) {
                    console.log(error);
                }
                setLoading(false);
            },
        });
    };

    const syncPage = () => {
        const resources = Object.entries(getResourceRefs());
        resources.forEach(([key, { area, comnCd }]: any) => {
            updateResource(area, comnCd);
        });
    };

    return createPortal(
        <>
            <div className="fixed top-0 left-0 h-screen w-screen z-[9996]" onClick={() => setIsOpen(false)}>
                <div
                    onClick={(event) => event.stopPropagation()}
                    className="fixed flex flex-col top-0 right-0 h-screen w-[320px] z-[9997] rounded-l-xl shadow-xl bg-background"
                >
                    <div className="h-[60px] flex items-center justify-between px-4">
                        <span className="text-xl">Renewal Code</span>
                        <button
                            className="flex items-center justify-center bg-background rounded h-[32px] w-[32px] hover:bg-black/10 transition-colors"
                            onClick={() => setIsOpen(false)}
                        >
                            <Icon icon="close" />
                        </button>
                    </div>

                    <div className="min-h-10 flex items-center justify-between px-4 hover:bg-white dark:hover:bg-black">
                        <div>Code Synchronization(All)</div>
                        <button type="button" onClick={syncAll}>
                            <Icon icon="download" size="sm" />
                        </button>
                    </div>

                    <div className="min-h-10 flex items-center justify-between px-4 hover:bg-white dark:hover:bg-black">
                        <div>Code Synchronization(Page)</div>
                        <button type="button" onClick={syncPage}>
                            <Icon icon="download" size="sm" />
                        </button>
                    </div>
                </div>
            </div>

            {loading && (
                <div className="fixed top-0 left-0 w-screen h-screen bg-black/10 z-[10050]">
                    <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                        <Icon icon="loading" className="animate-spin" size="4xl" />
                    </div>
                </div>
            )}
        </>,
        document.body,
    );
};

export const HeaderResourceButton = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <button
                type="button"
                className="flex items-center justify-center bg-header rounded h-[32px] w-[32px] hover:bg-black/10 transition-colors"
                onClick={() => setIsOpen((prev) => !prev)}
            >
                <Icon icon="setting" />
            </button>
            {isOpen && <Panel setIsOpen={setIsOpen} />}
        </>
    );
};
